import { connectAppStore } from "../../../Store/AppStore";
import PageDependencies from "../../../Feature/PageDependencies";

const ExternalScreenDataTable = (props) => {
    const {
        tryCatchFinally,
        stringCoding,
        layoutManager,
        getData,
        guid,
        toastPrint,
        useLocation,
        Fragment,
        useState,
        useNavigate,
        dataExtension,
        ServerSideDataTable,
        ModalDatatableItem,
    } = PageDependencies();
    const emptyGuid = guid.emptyGuid()
    var tableId = props.id === undefined ? emptyGuid : props.id;
    const redirectPathHex = stringCoding.encode(useLocation().pathname);
    const externalWallId = props.externalWallId;
    const designVariationVersionName = props.designVariationVersionName;
    const debug = layoutManager.Layout_GetDebugModel(props);
    const defaultViewModel = {
        designVariationVersionName: designVariationVersionName,
        selectedItemIds: [externalWallId]
    };
    const [extraPostModel, setExtraPostModel] = useState(defaultViewModel);
    const [data, setData] = useState([]);
    const [selectedIds, setSelectedIds] = useState([]);
    const [loading, setLoading] = useState({ isLoading: false, text: "" });
    //change model get url here if not using default model
    const getUrl = "api/Element/Accessor/GetVerticalShadingElements";
    const [tableReload, setTableReload] = useState("");
    const [modal, setModal] = useState({
        isOpen: false,
        title: "",
        message: "",
        comfirmButtonStyle: "",
        comfirmButtonText: "Comfirm",
        handleComfirm: () => {},
    });

    const nav = useNavigate();
    const columns = [
        { name: "externalWallName", text: "Wall", width: "30%" },
        { name: "name", text: "Name", width: "30%" },
        { name: "height", text: "Height (mm)", width: "10%" },
        { name: "width", text: "Width (mm)", width: "10%" },
        { name: "horizontalOffset", text: "Horrizontal Offset", width: "10%" },
        { name: "verticalOffset", text: "Vertical Offset", width: "10%" }
    ];

    const generateUrlParams = (elementId) => {
        return "/ElementAssessor/Detail/" + "ExternalScreen" + "/" + props.designVariationVersionName + "/" + props.developmentId + "/"+ props.projectId + "/" + props.designVariationId + "/" + props.zoneId + "/" + elementId + "/" + externalWallId + "/" + redirectPathHex;
    }

    const handleDeleteComfirm = async () => {
        await tryCatchFinally.asyncProcess(async ()=>{
          const selectedItemDic = dataExtension.getSelectedRowsDic(data, "elementType");
          setLoading({isLoading:true,text:"Deleting elements"});
          const selectResponse = await getData.processPost(
          true,
          "api/Element/Accessor/DeleteElements",
              {selectedItemDic: selectedItemDic, designVariationVersionName: props.designVariationVersionName, projectId: props.projectId, designVariationId: props.designVariationId}
          ); 
        toastPrint.printResponse(selectResponse);
        setTableReload(guid.newGuid());
        }, setLoading);
      }

    const handleDuplicatedComfirm = async () => {
        await tryCatchFinally.asyncProcess(async () => {
            const selectedItemDic = dataExtension.getSelectedRowsDic(data, "elementType");
            setLoading({ isLoading: true, text: "Duplicating elements" });
            const selectResponse = await getData.processPost(
                true,
                "api/Element/Accessor/CopyElements",
                { selectedItemDic: selectedItemDic, designVariationVersionName: props.designVariationVersionName, projectId: props.projectId, designVariationId: props.designVariationId, zoneId: props.zoneId, parentId: props.externalWallId }
            );
            toastPrint.printResponse(selectResponse);
            setTableReload(guid.newGuid());
        }, setLoading);
    }

      const actionOnDoubleClickRow = (model, newData) =>{
        nav(generateUrlParams(model.id));
      }

    const contextMenu = {
        items: {
          new: {
            name: "New",
            icon: "add",
            defaultAction: true,
            url: generateUrlParams(emptyGuid),
            isNavOption: true
          },
          separator: "---------",
          edit: {
              name: "Edit",
              icon: "edit",
              defaultAction: false,
                disabled: function () {
                return dataExtension.getSelectedRowDataIds(data).length === 0;
              },
            },
            delete: {
              name: "Delete",
              icon: "delete",
              url: "",
              defaultAction: false,
              disabled: function () {
                return dataExtension.getSelectedRowDataIds(data).length === 0;
              },
            },
            duplicate: {
              name: "Duplicate",
              icon: "copy",
              url: "",
              defaultAction: false,
              disabled: function () {
                return dataExtension.getSelectedRowDataIds(data).length === 0;
              },
            }
        },
        callBack: (
          contextMenuCallBackKey,
          contextMenuCallBackElement,
          contextMenuCallBackTableRoadData,
          localtion
        ) => {   
          if (contextMenuCallBackKey === "edit") {
            const selectedElementIds = dataExtension.getSelectedRowDataIds(data);
            if(selectedElementIds.length === 1){
               nav(generateUrlParams(selectedElementIds[0]));
            }else{
               const urlParams = props.designVariationVersionName + "/" + props.developmentId + "/" + props.projectId + "/" + props.designVariationId + "/" + props.zoneId + "/" + stringCoding.encodeObject(selectedElementIds) + "/" + redirectPathHex;
               nav("/ElementAssessor/MultipleDetail/ExternalScreen/" + urlParams);
            }
            return;
         }
         if (contextMenuCallBackKey === "delete"){
            setModal({
              ...modal,
              isOpen: true,
              title: "Delete elements",
              message:
                "Are you sure you want to delete " +
                dataExtension.getSelectedRowDataIds(data).length +
                " selected elment(s)?",
              comfirmButtonStyle: "danger",
              comfirmButtonText: "Confirm to delete",
              handleComfirm: handleDeleteComfirm,
            });
            }
            if (contextMenuCallBackKey === "duplicate") {
                setModal({
                    ...modal,
                    isOpen: true,
                    title: "Duplicate elements",
                    message:
                        "Are you sure you want to duplicate " +
                        dataExtension.getSelectedRowDataIds(data).length +
                        " selected element(s)?",
                    comfirmButtonStyle: "primary",
                    comfirmButtonText: "Confirm to duplicate",
                    handleComfirm: handleDuplicatedComfirm,
                });
            }
        },
      };

    return (
        <Fragment>
            {debug && <p>ExternalScreenDataTable</p>}
            {debug && <p>{JSON.stringify(dataExtension.getSelectedRowDataIds(data))}</p>}
            {debug && <p>{JSON.stringify(extraPostModel)}</p>}
            {debug && <p>redirect Url: {stringCoding.decode(redirectPathHex)}</p>}
            <ModalDatatableItem
            modal={modal}
            setModal={setModal}
            ></ModalDatatableItem>
            <ServerSideDataTable
                id={tableId}
                location="ExternalWallExternalScreenElement"
                data={data}
                setData={setData}
                reload={tableReload}
                columns={columns}
                actionOnDoubleClickRow = {actionOnDoubleClickRow}
                allowSelect
                allowSelectMultiple
                dataSource={{ isAuth: true, url: getUrl }}
                contextMenu={contextMenu}
                extraPostModel={extraPostModel}
                setSelectedItemIds = {setSelectedIds}
                removePaging ={true}
                removeSearch ={true}
                disableSorting
            ></ServerSideDataTable>
        </Fragment>
    );
}
export default connectAppStore(ExternalScreenDataTable);